import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { BsFillTrash3Fill } from "react-icons/bs";
import { useAuth } from "authContext";

function CourseNewsDeleteConfirmation({ onDeleteConfirm, newsItem }: any) {
  const [showModal, setShowModal] = useState<boolean>(false);

  const { userProfile } = useAuth();

  const handleDeleteClick = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    onDeleteConfirm(newsItem);
    setShowModal(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      {userProfile?.role !== "STUDENT" && (
        <BsFillTrash3Fill
          style={{ color: "darkred", cursor: "pointer" }}
          onClick={() => {
            handleDeleteClick();
          }}
          title={"Obriši novost"}
        />
      )}

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potvrdi brisanje novosti</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Jeste li sigurni da želite obrisati novost{" "}
          <strong>{newsItem.title}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Odustani
          </Button>
          <Button onClick={handleConfirm}>Obriši</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CourseNewsDeleteConfirmation;
